<template>
  <div class="col-md-12 p-0">
    <PopupDetailContract
      :id_contract="id_contract"
      v-on:exit="PopupClose"
      v-if="isEnablePopupDetail == 'detail'"
    />
    <PopupContractTerminate
      :id_contract="id_contract"
      v-on:exit="PopupClose"
      v-if="isEnablePopupDetail == 'terminate'"
    />
    <div class="schedule-version-modal" v-if="isEnableScheduleChooser">
      <div class="schedule-version-dialog">
        <button type="button" class="schedule-version-close" @click="isEnableScheduleChooser = false"><i class="ti ti-close"></i></button>
        <div class="schedule-version-heading"><span><i class="ti ti-calendar"></i></span><div><h4>Choose Schedule Experience</h4><p>Select the schedule version you want to use.</p></div></div>
        <div class="schedule-version-options">
          <button type="button" class="schedule-version-card" @click="ChooseShiftVersion('jobcon/shift-v2')"><span class="version-label">FAMILIAR</span><i class="ti ti-layout-grid2"></i><strong>Classic Schedule</strong><small>Existing workflow currently used by administrators.</small></button>
          <button type="button" class="schedule-version-card is-new" @click="ChooseShiftVersion('jobcon/shift-v3')"><span class="version-label">VERSION 3</span><i class="ti ti-calendar"></i><strong>New Schedule</strong><small>Newest calendar experience with an improved workflow.</small></button>
        </div>
      </div>
    </div>
    <div class="popup popup-sm" v-if="isEnablePopup">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5 class="text-left">
          Remove Data<br /><br />
          <p class="p-0 m-0">
            Data will be permanently deleted, Are you sure want to remove the
            data ?
          </p>
          <span class="text-secondary"
            >Please choose the option to delete data</span
          >
          <hr />
        </h5>
        <div class="text-right">
          <a
            href="javascript:;"
            @click="isEnablePopup = false"
            class="btn btn-secondary"
            >Cancel</a
          >
          &nbsp; &nbsp;
          <a href="javascript:;" @click="removeData()" class="btn btn-warning"
            >Remove</a
          >
          <!-- &nbsp;OR&nbsp;
          <a
            href="javascript:;"
            @click="removeData('contract')"
            class="btn btn-primary"
            >Contract Only</a
          > -->
        </div>
      </div>
    </div>
    <section class="contract-hero">
      <div>
        <span class="contract-hero__eyebrow">CONTRACT MANAGEMENT</span>
        <h2>Job Contract</h2>
        <p>Kelola kontrak, periode kerja, officer, shift, dan area pekerjaan dalam satu tempat.</p>
      </div>
      <div class="contract-hero__summary">
        <i class="ti ti-briefcase"></i>
        <div>
          <strong>{{ data_model.total | formatPrice }}</strong>
          <span>Total Contracts</span>
        </div>
      </div>
    </section>
    <div class="card contract-card">
      <div class="card-body">
        <div class="table-header">
          <h5 class="contract-card__title">
            Contract Directory <br />
            <small
              >Total Records :
              <b>{{ data_model.total | formatPrice }}</b></small
            >
          </h5>

          <div class="group-search pull-right">
            <a class="btn" @click="tableRefresh()"
              ><i class="ti ti-reload"></i
            ></a>
            <a class="btn" @click="isActiveSearch()"
              ><i
                :class="isEnableTools == false ? 'ti ti-search' : 'ti ti-close'"
              ></i
            ></a>
            <div class="select" v-if="isEnableTools">
              <select v-model="meta_data.skey" @change="meta_data.sval = ''">
                <option value="">-- Choose Field --</option>
                <option value="contract.contract_number">
                  Contract Number
                </option>
                <option value="contract.description">Description</option>
                <option value="client.name">Client Name</option>
                <option value="client.office_address">Client Address</option>
              </select>
            </div>
            <div class="group" v-if="isEnableTools">
              <input
                type="date"
                v-model="meta_data.sval"
                v-if="
                  meta_data.skey == 'created_at' ||
                  meta_data.skey == 'updated_at'
                "
              />
              <input
                type="text"
                v-model="meta_data.sval"
                placeholder="Enter Keyword ...."
                v-else
              />
              <a class="btn" @click="tableSearch()"> SEARCH DATA </a>
            </div>
            <router-link
              :to="{ name: 'jobcon/contract-store', query: listQuery }"
              class="btn btn-primary"
              v-if="$store.state.app.access.includes('insert')"
              ><i class="ti ti-plus"></i> Create New</router-link
            >
            <!-- <a @click="syncData()" class="btn btn-warning" v-if="isRoot">
              <i class="ti ti-reload"></i> Sync Data
            </a> -->
          </div>
          <div class="group-filter contract-filters" v-if="!isClient">
            <div class="row">
              <!-- <div class="col-md-3">
                <label class="text-secondary">Start Date</label><br />
                <div class="form-group mr-2">
                  <span class="text-secondary">Year</span>
                  <select
                    class="form-control"
                    v-model="meta_filter.sd_year"
                    @change="tableQuery()"
                  >
                    <option value="all">-- All Year --</option>
                    <option
                      v-for="(items, idx) in data_model.start_year"
                      :key="idx"
                      :value="items.YEAR"
                    >
                      {{ items.YEAR }}
                    </option>
                  </select>
                </div>
                <div class="form-group mr-2">
                  <span class="text-secondary">Month</span>
                  <select
                    class="form-control"
                    v-model="meta_filter.sd_month"
                    @change="tableQuery()"
                  >
                    <option value="all">-- All Month --</option>
                    <option
                      v-for="(items, idx) in data_model.start_month"
                      :key="idx"
                      :value="items.MONTH"
                    >
                      {{ items.MONTH | convertStringMonth }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="text-secondary">End Date</label><br />
                <div class="form-group mr-2">
                  <span class="text-secondary">Year</span>
                  <select
                    class="form-control"
                    v-model="meta_filter.ed_year"
                    @change="tableQuery()"
                  >
                    <option value="all">-- All Year --</option>
                    <option
                      v-for="(items, idx) in data_model.end_year"
                      :key="idx"
                      :value="items.YEAR"
                    >
                      {{ items.YEAR }}
                    </option>
                  </select>
                </div>
                <div class="form-group mr-2">
                  <span class="text-secondary">Month</span>
                  <select
                    class="form-control"
                    v-model="meta_filter.ed_month"
                    @change="tableQuery()"
                  >
                    <option value="all">-- All Month --</option>
                    <option
                      v-for="(items, idx) in data_model.end_month"
                      :key="idx"
                      :value="items.MONTH"
                    >
                      {{ items.MONTH | convertStringMonth }}
                    </option>
                  </select>
                </div>
              </div> -->
              <div class="col-md-6">
                <div class="form-group mr-3">
                  <label class="text-secondary">Choose Date Range</label><br />
                  <div class="mt-3">
                    <date-picker
                      v-model="period"
                      value-type="format"
                      type="date"
                      format="YYYY-MM-DD"
                      placeholder="Pilih Range Tanggal"
                      width="100%"
                      :clearable="false"
                      @change="tableQuery(1)"
                      range
                      confirm
                    >
                      <template v-slot:header="{ emit }">
                        <div class="row text-left">
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectLastDay(emit, 3)"
                            >
                              3 hari sebelumnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectLastDay(emit, 7)"
                            >
                              7 hari sebelumnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectLastDay(emit, 30)"
                            >
                              30 hari sebelumnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectLastDay(emit, 60)"
                            >
                              60 hari sebelumnya
                            </button>
                          </div>
                        </div>
                      </template>
                      <template v-slot:footer="{ emit }">
                        <div class="row text-left mb-2">
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectNextDay(emit, 3)"
                            >
                              3 hari selanjutnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectNextDay(emit, 7)"
                            >
                              7 hari selanjutnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectNextDay(emit, 30)"
                            >
                              30 Hari selanjutnya
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="mx-btn mx-btn-text"
                              @click="selectNextDay(emit, 60)"
                            >
                              60 Hari selanjutnya
                            </button>
                          </div>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group float-right" v-if="isRoot">
                  <br />
                  <label>Branch Station</label>
                  <SelectBranch
                    :default_id="meta_filter.id_branch"
                    v-on:processBranch="processBranch"
                    v-on:loaded="setBranchDirectory"
                  />
                </div>
                <div class="form-group float-right mr-2">
                  <br />
                  <label class="text-secondary">Contract Status</label>
                  <select
                    class="form-control"
                    v-model="meta_filter.status"
                    @change="tableQuery(1)"
                  >
                    <option value="all">-- All Contract Status --</option>
                    <option value="draft">Draft</option>
                    <!-- <option value="complete">Complete</option> -->
                    <option value="on_going">On Going</option>
                    <option value="terminate">Terminate</option>
                    <option value="finished">Finished</option>
                    <!-- <option value="out_of_date">Out of Date</option> -->
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-cover">
          <table
            class="table-hover"
            :style="{ minWidth: isRoot ? '2050px' : '1900px' }"
          >
            <thead>
              <tr>
                <th>No</th>
                <th
                  width="70"
                  class="no-filter text-center"
                  v-if="JSON.parse($store.state.app.access).length > 1"
                >
                  Action
                </th>
                <th
                  :class="meta_data.okey == 'client.name' ? 'active' : ''"
                  v-on:click="tableOrdering('client.name')"
                >
                  Client Name
                </th>
                <th class="no-filter" v-if="isRoot">Branch Station</th>
                <th
                  :class="
                    meta_data.okey == 'contract.contract_number' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.contract_number')"
                >
                  Contract Number
                </th>
                <th
                  :class="meta_data.okey == 'contract.status' ? 'active' : ''"
                  v-on:click="tableOrdering('contract.status')"
                >
                  Contract Status
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.start_date' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.start_date')"
                >
                  Contract Period
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.man_power' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.man_power')"
                >
                  MP Request
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.description' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.description')"
                >
                  Description
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.contract_date' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.contract_date')"
                >
                  Contract Date
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.created_at' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.created_at')"
                >
                  Created Date
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.updated_at' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.updated_at')"
                >
                  Updated Date
                </th>
              </tr>
            </thead>
            <tbody v-if="data_model.total > 0">
              <tr v-for="(items, idx) in data_model.data" :key="idx">
                <td>{{ idx + data_model.from }}</td>
                <td v-if="JSON.parse($store.state.app.access).length > 1">
                  <div class="tools">
                    <a href="javascript:;">Tools</a>
                    <ul>
                      <li style="display: flex">
                        <a
                          href="javascript:;"
                          @click="OpenContractPopup(items.id, 'detail')"
                          ><i class="text-primary ti ti-file"></i> Detail
                          Contract</a
                        >
                      </li>
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('terminate') &&
                          (items.status == 'draft' ||
                            items.status == 'complete' ||
                            items.status == 'on_going')
                        "
                      >
                        <a href="javascript:;" @click="editContract(items.id)"
                          ><i class="text-warning ti ti-pencil"></i> Edit
                          Contract</a
                        >
                      </li>
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('assign') &&
                          items.status !== 'terminate' &&
                          items.status !== 'finished'
                        "
                      >
                        <a href="javascript:;" @click="AssignOfficer(items.id)"
                          ><i class="text-success ti ti-user"></i> Manage -
                          Officer</a
                        >
                      </li>
                      <!-- <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('task') &&
                          items.status !== 'terminate' &&
                          items.status !== 'finished'
                        "
                      >
                        <a href="javascript:;" @click="AssignJobTask(items.id)"
                          ><i class="text-success ti ti-layout"></i> Manage -
                          Section Room
                        </a>
                      </li> -->
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('task') &&
                          items.status !== 'terminate' &&
                          items.status !== 'finished'
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="AssignJobTaskNew(items.id)"
                          ><i class="text-success ti ti-layout"></i> Manage -
                          Section Room
                          <!-- V2 -->
                        </a>
                      </li>
                      <!-- <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('shift') &&
                          items.status !== 'terminate' &&
                          items.status !== 'finished'
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="AssignShiftWorker(items.id)"
                          ><i class="text-success ti ti-time"></i> Manage -
                          Schedule Shift Worker</a
                        >
                      </li> -->
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('shift') &&
                          items.status !== 'terminate' &&
                          items.status !== 'finished'
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="OpenShiftVersionChooser(items.id)"
                          ><i class="text-success ti ti-time"></i> Manage -
                          Schedule Shift Worker
                          <!-- V2 -->
                        </a>
                      </li>
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('terminate') &&
                          (items.status == 'on_going' ||
                            items.status == 'finished')
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="OpenContractPopup(items.id, 'terminate')"
                          ><i class="text-warning ti ti-lock"></i> Terminate
                          Contract</a
                        >
                      </li>
                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('terminate') &&
                          // items.renewal_id == null &&
                          items.status == 'finished'
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="editContractRenewal(items.id)"
                          ><i class="text-warning ti ti-pencil"></i> Renewal</a
                        >
                      </li>

                      <li
                        style="display: flex"
                        v-if="
                          $store.state.app.access.includes('delete') &&
                          items.status == 'draft'
                        "
                      >
                        <a href="javascript:;" @click="preparationRemmove(idx)"
                          ><i class="text-danger ti ti-trash"></i> Remove</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <b>{{ items.client_name }}</b>
                </td>
                <td class="contract-branch-cell" v-if="isRoot">
                  <span class="contract-branch-badge">
                    <span class="contract-branch-badge__icon">
                      <i class="ti ti-location-pin"></i>
                    </span>
                    <span class="contract-branch-badge__content">
                      <strong>{{ branchInfo(items.id_branch).name }}</strong>
                      <small v-if="branchInfo(items.id_branch).code">
                        {{ branchInfo(items.id_branch).code }}
                      </small>
                    </span>
                  </span>
                </td>
                <td width="160">{{ items.contract_number }}</td>
                <td>
                  <span :class="items.status | contractStatus">
                    {{ items.status | cleanString }}</span
                  >
                </td>
                <td width="200">
                  {{ items.start_date | moment("YYYY-MM-DD") }} -
                  {{ items.end_date | moment("YYYY-MM-DD") }}
                </td>
                <td class="pr-3" width="400">
                  <span
                    class=""
                    v-for="(initems, index) in JSON.parse(items.man_power)"
                    :key="index"
                  >
                    {{ initems.total }} ( {{ initems.job }} )
                    <span v-if="index % 2 == 0">,</span>
                  </span>
                </td>
                <td width="400">
                  {{ items.description !== null ? items.description : "....." }}
                </td>
                <td width="120">
                  {{ items.contract_date | moment("DD/MM/YYYY") }}
                </td>
                <td>{{ items.created_at | moment("DD/MM/YYYY") }}</td>
                <td>{{ items.updated_at | moment("DD/MM/YYYY") }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td :colspan="isRoot ? 12 : 11">
                  <div class="no-data" v-if="!$store.state.loading.status">
                    Sorry data is not available
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <small class="info"
            ><i class="ti ti-split-h"></i> Scroll horizontal to view
            data.</small
          >
          <paginate
            :page-count="parseInt(data_model.last_page)"
            :click-handler="tableQuery"
            :force-page="Math.max(0, page - 1)"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import router from "../../../router";
import PopupDetailContract from "../@PopupDetailContract";
import PopupContractTerminate from "../@PopupContractTerminate";
import SelectBranch from "../../Branch/@SelectBranch";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

import { mapState } from "vuex";

export default {
  data() {
    return {
      isClient: false,
      isRoot: false,
      isEnablePopupDetail: false,
      isEnablePopup: false,
      isEnableScheduleChooser: false,
      scheduleContractId: null,
      isEnableTools: false,
      isEnableOrder: false,
      id_contract: null,
      date_range: "",
      // period: ["2021-09-01", "2021-09-16"],
      period: [
        new Date(new Date().setFullYear(new Date().getFullYear() - 2))
          .toISOString()
          .split("T")[0],
        new Date(new Date().setFullYear(new Date().getFullYear() + 2))
          .toISOString()
          .split("T")[0],
      ],
      active_selected_id_contract: "",
      active_selected_id_client: "",
      page: 1,
      meta_url: "contract",
      meta_data: {
        okey: "created_at",
        oval: "desc",
        wkey: "",
        wval: "",
        skey: "",
        sval: "",
      },
      meta_filter: {
        status: "all",
        sd_year: "all",
        sd_month: "all",
        ed_year: "all",
        ed_month: "all",
        id_branch: "all",
      },
      branchDirectory: [],
    };
  },
  components: {
    PopupDetailContract,
    PopupContractTerminate,
    SelectBranch,
    DatePicker,
  },
  computed: {
    ...mapState("crud", {
      data_model: (state) => state.data_model,
      msg_error: (state) => state.error,
    }),
    listQuery() {
      return this.buildListQuery(this.page);
    },
  },
  created() {
    const roleUserPrivilegesName = ["root", "hrd nasional"];

    // filter branch
    if (
      !roleUserPrivilegesName.includes(
        localStorage.getItem("userPrivilegesName")
      )
    ) {
      this.isClient =
        localStorage.getItem("userIdPrivileges") == 14 ? true : false;
      this.meta_filter.id_branch = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }

    this.restoreListQuery();
    this.tableQuery(this.page);
  },
  methods: {
    selectLastDay(emit, range) {
      const start = new Date();
      const end = new Date();
      start.setTime(start.getTime() - range * 24 * 3600 * 1000);
      const date = [start, end];
      emit(date);
    },
    selectNextDay(emit, range) {
      const start = new Date();
      const end = new Date();
      end.setTime(end.getTime() + range * 24 * 3600 * 1000);
      const date = [start, end];
      emit(date);
    },
    processBranch(data) {
      this.meta_filter.id_branch = data;
      this.tableQuery(1);
    },
    setBranchDirectory(branches) {
      this.branchDirectory = Array.isArray(branches) ? branches : [];
    },
    branchInfo(idBranch) {
      const branch = this.branchDirectory.find(
        (item) => String(item.id) === String(idBranch)
      );

      return {
        name: branch ? branch.name : "Branch #" + idBranch,
        code: branch && branch.branch_code ? branch.branch_code : "",
      };
    },
    PopupClose(initial) {
      this.isEnablePopupDetail = false;
      if (initial) {
        this.tableQuery();
      }
    },
    OpenContractPopup(id, initial) {
      this.id_contract = id;
      this.isEnablePopupDetail = initial;
    },

    isActiveSearch() {
      this.isEnableTools = !this.isEnableTools;
    },

    tableSearch() {
      if (this.meta_data.skey == "") {
        alert("🙏, Please choose target field");
        return;
      }
      if (this.meta_data.sval == "") {
        alert("🙏, Please enter the keyword");
        return;
      }
      this.tableQuery(1);
    },
    tableOrdering(key) {
      this.isEnableOrder = !this.isEnableOrder;
      this.meta_data.okey = key;
      this.meta_data.oval = this.isEnableOrder ? "ASC" : "DESC";
      this.tableQuery(this.page);
    },
    formatDate(date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      let newDate = [year, month, day].join("-");

      return newDate;
    },
    tableQuery(pageNum) {
      // console.log(pageNum);
      // { key: "contract.start_date", val: this.period[0] },
      //     { key: "contract.end_date", val: this.period[1] },
      this.page = parseInt(pageNum || this.page || 1, 10);
      this.syncListQuery();
      let data = {
        url: this.meta_url + "/data",
        offset: this.page,
        // daterange: { start: this.date_range[0], end: this.date_range[1] },
        search: { key: this.meta_data.skey, value: this.meta_data.sval },
        order: { key: this.meta_data.okey, value: this.meta_data.oval },
        where: { key: this.meta_data.wkey, value: this.meta_data.wval },
        period_start: this.period && this.period[0] ? this.period[0] : "",
        period_end: this.period && this.period[1] ? this.period[1] : "",
        filter: [
          { key: "contract.status", val: this.meta_filter.status },
          // { key: "sd_year", val: this.meta_filter.sd_year },
          // { key: "sd_month", val: this.meta_filter.sd_month },
          // { key: "ed_year", val: this.meta_filter.ed_year },
          // { key: "ed_month", val: this.meta_filter.ed_month },
          { key: "contract.id_branch", val: this.meta_filter.id_branch },
          //{key : 'contract-station', val:localStorage.getItem('userContract')}
        ],
      };

      this.$store.state.loading.msg = "Processing Fetching Data...";
      this.$store.state.loading.status = true;
      this.$store.dispatch("crud/getData", data);
    },
    syncData() {
      this.$store.state.loading.msg = "Process Synchronization ...";
      this.$store.state.loading.status = true;

      axios
        .get(this.meta_url + "/sync-data")
        .then((res) => {
          // console.log(res);
          let response = res.data;
          this.$store.state.loading.status = true;
          this.$store.state.loading.msg = response.msg;
        })
        .finally(() => {
          this.$store.state.loading.status = false;
        });
    },
    tableRefresh() {
      this.meta_data.skey = "";
      this.meta_data.sval = "";
      this.$store.state.loading.msg = "Refreshing Data...";
      this.$store.state.loading.status = true;
      // this.$store.dispatch("crud/getData", { url: this.meta_url + "/data" });
      this.tableQuery(1);
    },
    tableCreateData() {
      this.model_form = {};
      this.mode_form = "store";
    },
    tableUpdate(id) {
      this.openContractPage("jobcon/contract-update", id);
    },
    AssignOfficer(id) {
      this.openContractPage("jobcon/contract-assign", id);
    },
    AssignShiftWorker(id) {
      this.openContractPage("jobcon/shift", id);
    },
    AssignShiftWorkerV2(id) {
      this.openContractPage("jobcon/shift-v2", id);
    },
    OpenShiftVersionChooser(id) {
      this.scheduleContractId = id;
      this.isEnableScheduleChooser = true;
    },
    ChooseShiftVersion(routeName) {
      const id = this.scheduleContractId;
      this.isEnableScheduleChooser = false;
      this.openContractPage(routeName, id);
    },
    AssignJobTask(id) {
      this.openContractPage("jobcon/task", id);
    },
    AssignJobTaskNew(id) {
      this.openContractPage("jobcon/task-section", id);
    },
    preparationRemmove(idx) {
      let model = this.data_model.data[idx];
      this.active_selected_id_contract = model.id;
      this.active_selected_id_client = model.id_client;
      this.isEnablePopup = true;
    },
    async removeData(initial) {
      this.$store.state.loading.msg = "Processing Remove Data Contract...";
      this.$store.state.loading.status = true;

      let data = {
        url: this.meta_url + "/destroy/" + this.active_selected_id_contract,
      };
      let res = await this.$store.dispatch("crud/deleteData", data);

      if (res && res.result == "ok") {
        this.$store.state.alert.status = true;
        this.$store.state.alert.msg = res.msg;
        this.tableQuery();
        this.isEnablePopup = false;
        // if (initial == "contract&client") {
        //   this.$store.state.loading.msg = "Processing Remove Data Client...";
        //   this.$store.state.loading.status = true;

        //   let data = {
        //     url: "client/master-destroy/" + this.active_selected_id_client,
        //     disableAlert: true,
        //   };
        //   let res = await this.$store.dispatch("crud/deleteData", data);
        //   this.$store.state.alert.status = true;
        //   if (res && res.result == "ok") {
        //     this.$store.state.alert.msg = res.msg;
        //   } else {
        //     this.$store.state.alert.msg =
        //       "Successfully only remove data contract, Cannot remove Data client. This client is still use in another contract";
        //   }

        //   this.isEnablePopup = false;
        //   this.tableQuery();
        // } else {
        //   this.$store.state.alert.status = true;
        //   this.$store.state.alert.msg = res.msg;

        //   this.tableQuery();
        //   this.isEnablePopup = false;
        // }
      } else {
        this.isEnablePopup = false;
        this.$store.state.alert.status = false;
        setTimeout(() => {
          this.$store.state.alert.type = "warning";
          this.$store.state.alert.msg = res.msg;
          this.$store.state.alert.status = true;
        }, 300);
      }
    },
    editContract(id) {
      this.openContractPage("jobcon/contract-edit", id);
    },
    editContractRenewal(id) {
      this.openContractPage("jobcon/contract-renewal", id);
    },
    buildListQuery(pageNum) {
      return {
        page: String(pageNum || 1),
        search_key: this.meta_data.skey || "",
        search_value: this.meta_data.sval || "",
        status: this.meta_filter.status || "all",
        period_start: this.period && this.period[0] ? this.period[0] : "",
        period_end: this.period && this.period[1] ? this.period[1] : "",
        branch: this.meta_filter.id_branch || "all",
        order_key: this.meta_data.okey || "created_at",
        order_value: (this.meta_data.oval || "desc").toLowerCase(),
      };
    },
    restoreListQuery() {
      const query = this.$route.query || {};
      this.page = Math.max(1, parseInt(query.page || 1, 10));
      this.meta_data.skey = query.search_key || "";
      this.meta_data.sval = query.search_value || "";
      this.meta_data.okey = query.order_key || "created_at";
      this.meta_data.oval = (query.order_value || "desc").toLowerCase();
      this.isEnableOrder = this.meta_data.oval.toLowerCase() === "asc";
      this.meta_filter.status = query.status || "all";

      if (query.period_start && query.period_end) {
        this.period = [query.period_start, query.period_end];
      }
      if (this.isRoot && query.branch) {
        this.meta_filter.id_branch = query.branch;
      }
      this.isEnableTools = Boolean(this.meta_data.skey || this.meta_data.sval);
    },
    syncListQuery() {
      const query = this.buildListQuery(this.page);
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace(
          { name: "jobcon/contract-data", query },
          () => {},
          () => {}
        );
      }
    },
    openContractPage(name, id) {
      localStorage.setItem("QUERY_ID", id);
      router.push({
        name,
        query: Object.assign({}, this.buildListQuery(this.page), {
          contract_id: String(id),
        }),
      });
    },
  },
};
</script>
<style scoped>
.mx-range-wrapper {
  width: 630px !important;
}

.contract-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, 0.16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  overflow: hidden;
  min-height: 150px;
  padding: 25px 28px;
  position: relative;
}

.contract-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 240px;
  position: absolute;
  right: -75px;
  top: -115px;
  width: 240px;
}

.contract-hero__eyebrow {
  color: #8ef7f0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.contract-hero h2 {
  color: #fff;
  font-size: 24px;
  margin: 5px 0 6px;
}

.contract-hero p {
  margin: 0;
  opacity: 0.9;
}

.contract-hero__summary {
  align-items: center;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 13px;
  display: flex;
  gap: 13px;
  min-width: 160px;
  padding: 12px 18px;
  position: relative;
  z-index: 1;
}

.contract-hero__summary i { font-size: 26px; }
.contract-hero__summary strong { display: block; font-size: 22px; line-height: 1.1; }
.contract-hero__summary span { display: block; font-size: 11px; margin-top: 5px; }

.contract-card {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(27, 58, 89, 0.09);
  overflow: visible;
}

.contract-card__title { margin-bottom: 18px; }
.contract-filters {
  background: #f7f9fc;
  border: 1px solid #edf1f5;
  border-radius: 12px;
  clear: both;
  margin: 18px 0 22px;
  padding: 8px 14px;
}

.table-cover {
  border: 1px solid #e6ebf1;
  border-radius: 12px;
}

.table-cover thead th {
  background: #f8fafc;
  color: #5d6b7c;
  font-size: 11px;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}
.contract-branch-cell {
  min-width: 175px;
}
.contract-branch-badge {
  align-items: center;
  background: linear-gradient(135deg, #eef9fb 0%, #f3fbf8 100%);
  border: 1px solid #cfe8e8;
  border-radius: 10px;
  display: inline-flex;
  gap: 9px;
  max-width: 190px;
  padding: 7px 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;
  width: 100%;
}
.contract-branch-badge__icon {
  align-items: center;
  background: #d8f1f1;
  border-radius: 8px;
  color: #23869a;
  display: flex;
  flex: 0 0 32px;
  font-size: 15px;
  height: 32px;
  justify-content: center;
}
.contract-branch-badge__content {
  min-width: 0;
}
.contract-branch-badge strong {
  color: #31576a;
  display: block;
  font-size: 11px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contract-branch-badge small {
  color: #4b9297;
  display: block;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-top: 3px;
  text-transform: uppercase;
}
.table-cover tbody tr:hover .contract-branch-badge {
  border-color: #94d0d2;
  box-shadow: 0 5px 14px rgba(42, 130, 145, 0.12);
  transform: translateY(-1px);
}
.schedule-version-modal{align-items:center;background:rgba(12,25,38,.76);bottom:0;display:flex;justify-content:center;left:0;padding:20px;position:fixed;right:0;top:0;z-index:1300}.schedule-version-dialog{background:#fff;border-radius:14px;box-shadow:0 24px 70px rgba(0,0,0,.3);max-width:720px;padding:28px;position:relative;width:100%}.schedule-version-close{background:#eef3f6;border:0;border-radius:50%;color:#647687;height:32px;position:absolute;right:18px;top:18px;width:32px}.schedule-version-heading{align-items:center;display:flex;gap:12px;margin-bottom:22px}.schedule-version-heading>span{align-items:center;background:#e9f5f6;border-radius:10px;color:#318da0;display:flex;font-size:20px;height:44px;justify-content:center;width:44px}.schedule-version-heading h4{color:#284158;font-size:18px;margin:0 0 3px}.schedule-version-heading p{color:#7b8996;margin:0}.schedule-version-options{display:grid;gap:14px;grid-template-columns:repeat(2,minmax(0,1fr))}.schedule-version-card{background:#f8fafc;border:1px solid #dfe7ee;border-radius:11px;color:#40556a;cursor:pointer;display:flex;flex-direction:column;min-height:180px;padding:20px;text-align:left;transition:all .2s ease}.schedule-version-card:hover{border-color:#62abb8;box-shadow:0 10px 22px rgba(49,128,146,.14);transform:translateY(-2px)}.schedule-version-card>i{color:#46839d;font-size:28px;margin:14px 0}.schedule-version-card strong{font-size:14px}.schedule-version-card small{color:#7a8998;margin-top:6px}.schedule-version-card.is-new{background:#f1faf9;border-color:#b9dfdc}.version-label{align-self:flex-start;background:#e3ebf1;border-radius:999px;color:#617384;font-size:9px;font-weight:700;padding:4px 7px}.is-new .version-label{background:#d5f0ea;color:#21745f}

@media (max-width: 767px) {
  .schedule-version-dialog{padding:22px 16px}.schedule-version-heading{padding-right:28px}.schedule-version-options{grid-template-columns:1fr}.schedule-version-card{min-height:145px}
  .contract-hero { align-items: flex-start; flex-direction: column; padding: 22px; }
  .contract-hero__summary { margin-top: 18px; width: 100%; }
  .contract-card .card-body { padding: 18px 14px; }
  .group-search { display: flex; flex-wrap: wrap; gap: 8px; width: 100%; }
  .group-search .select, .group-search .group { width: 100%; }
  .group-search .group input { width: calc(100% - 110px); }
  .contract-filters .col-md-6 { width: 100%; }
  .contract-filters .float-right { float: none !important; margin-right: 0 !important; width: 100%; }
}
</style>
